import { ButtonV2 } from '@cimplico/components';
import plural from '../../utilities/plural';

type RepliesToggleProps = {
    /**
     * Whether new reply can be created
     */
    canCreate: boolean;
    /**
     * Number of replies for the comment/query
     */
    replyCount: number;
    /**
     * Whether toggle is being enabled
     */
    enabled: boolean;
    /**
     * Callback when toggle is being updated
     */
    onToggle: () => void;
};

/**
 * Toggle at the bottom right corner of the card
 * On toggle show or hide replies list section
 */
function RepliesToggle({ canCreate, replyCount, enabled, onToggle }: RepliesToggleProps): JSX.Element {
    let label = '';

    if (replyCount === 0) {
        label = enabled ? 'Hide' : canCreate ? 'Add a reply' : 'Show 0 replies';
    } else {
        const suffix = plural(replyCount, 'reply', 'replies');
        label = enabled ? `Hide ${replyCount} ${suffix}` : `Show ${replyCount} ${suffix}`;
    }

    return !canCreate && replyCount === 0 ? <></> : <ButtonV2 label={label} type="hollow" size="sm" onClick={(): void => onToggle()} />;
}

export default RepliesToggle;
